import React from "react";
import { motion } from "framer-motion";

const NODES = [
  { x: 90, y: 80, label: "Endpoints" },
  { x: 250, y: 40, label: "Identity" },
  { x: 430, y: 70, label: "Email" },
  { x: 810, y: 90, label: "Cloud" },
  { x: 60, y: 250, label: "Network" },
  { x: 840, y: 250, label: "SaaS" },
  { x: 120, y: 420, label: "Servers" },
  { x: 320, y: 470, label: "Containers" },
  { x: 560, y: 470, label: "APIs" },
  { x: 790, y: 420, label: "OT / ICS" },
];

const CENTER = { x: 450, y: 260 };

export const NetworkMesh = ({ className = "", labels = true }) => (
  <svg
    viewBox="0 0 900 520"
    className={`h-full w-full ${className}`}
    aria-hidden
    data-testid="network-mesh"
    preserveAspectRatio="xMidYMid slice"
  >
    <defs>
      <radialGradient id="meshCore" cx="50%" cy="50%">
        <stop offset="0%" stopColor="#8E9AEA" stopOpacity="0.55" />
        <stop offset="100%" stopColor="#8E9AEA" stopOpacity="0" />
      </radialGradient>
    </defs>

    <circle cx={CENTER.x} cy={CENTER.y} r="150" fill="url(#meshCore)" />

    {NODES.map((n, i) => (
      <g key={n.label}>
        <line
          x1={n.x}
          y1={n.y}
          x2={CENTER.x}
          y2={CENTER.y}
          stroke="#8E9AEA"
          strokeOpacity="0.18"
          strokeWidth="1"
        />
        <motion.circle
          r="3.5"
          fill="#8E9AEA"
          initial={{ cx: n.x, cy: n.y, opacity: 0, r: 3.5 }}
          animate={{ cx: [n.x, CENTER.x], cy: [n.y, CENTER.y], opacity: [0, 1, 1, 0], r: 3.5 }}
          transition={{ duration: 3.2, repeat: Infinity, delay: i * 0.45, ease: "easeInOut" }}
        />
        <motion.circle
          cx={n.x}
          cy={n.y}
          r="5"
          fill="#0B0F1A"
          stroke="#8E9AEA"
          strokeOpacity="0.7"
          strokeWidth="1.5"
          initial={{ r: 5 }}
          animate={{ r: [5, 7, 5] }}
          transition={{ duration: 2.6, repeat: Infinity, delay: i * 0.3 }}
        />
        {labels && (
          <text
            x={n.x}
            y={n.y - 14}
            textAnchor="middle"
            fill="#A6B0C9"
            fontSize="11"
            fontFamily="Manrope, sans-serif"
            letterSpacing="0.08em"
          >
            {n.label.toUpperCase()}
          </text>
        )}
      </g>
    ))}

    <motion.circle
      cx={CENTER.x}
      cy={CENTER.y}
      r="34"
      fill="none"
      stroke="#8E9AEA"
      strokeOpacity="0.5"
      strokeWidth="1.5"
      initial={{ r: 34, opacity: 0.5 }}
      animate={{ r: [34, 78], opacity: [0.5, 0] }}
      transition={{ duration: 2.8, repeat: Infinity, ease: "easeOut" }}
    />
    <circle cx={CENTER.x} cy={CENTER.y} r="30" fill="#0D1322" stroke="#8E9AEA" strokeWidth="1.5" />
    <text
      x={CENTER.x}
      y={CENTER.y + 4}
      textAnchor="middle"
      fill="#FFFFFF"
      fontSize="12"
      fontWeight="700"
      fontFamily="Sora, sans-serif"
      letterSpacing="0.14em"
    >
      SOC
    </text>
  </svg>
);
